export default __webpack_public_path__ + "static/media/wohngeldzuschuss.3bdb10ad.svg";